import { RegExpUtility } from "../RegExpUtility";

export class SplitLineInfo
{
  content:string;
  breakType:string;
}

export class LinesSplitter
{
  split( text:string ):SplitLineInfo[]
  {
    let results = RegExpUtility.splitLinesCaptureBreaks( text );

    let lines:SplitLineInfo[] = [];

    for ( let i = 0; i < results.length; i += 2 )
    {
      let line = new SplitLineInfo();
      line.content = (results[ i ] );
      
      if ( ( i + 1 ) < results.length )
      {
        line.breakType = results[ i + 1 ];
      }

      lines.push( line );
    } 

    console.log( "split:", text, results, lines )

    return lines;
  }
}
